import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchRecords } from './club-user.action';

@Injectable({ providedIn: 'root' })
export class ClubUserTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                first_name: '', 
                email: '', 
                role: null, //Null for select list
                last_logged_in: '',
                get_new_task_email: ''
            };

    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'first_name';
    initialSortDirection = 'asc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    roles = [];
    hasFilter = false;
    clubId = "";
    columns = [
                { prop: 'first_name', name: 'CLUB_USER.full-name', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'email', name: 'CLUB_USER.email', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'role', name: 'CLUB_USER.role', sortable: false, hasFilter: true, filter: "select", options: 'roles', options_id: "id", options_label: "role_name" },
                { prop: 'last_logged_in', name: 'CLUB_USER.user-logged-in', sortable: true, hasFilter: true, filter: "date"},
                { prop: 'get_new_task_email', name: 'CLUB_USER.new-task-email', sortable: true, hasFilter: false, filter: "input"},
                { prop: 'actions', name: 'COMMON.actions', sortable: false, hasFilter: false, filter: ""},
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchRecords({clubId: this.clubId}));
    }

    hasActiveFilters(){
        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }

    resetFilters(){
        this.filters = {
            first_name: '', 
            email: '', 
            role: null, 
            last_logged_in: '',
            get_new_task_email: ''
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;

        this.loadRecords();
    }

}